/**
 * STANDARD - An invoice line item for each item in the orders: ABC-1234 SKU - $10.00
 *
 * SUM_BY_ORDER - A single invoice line item for each of the orders, and the total of all of those items - ABC-1234 SKU and Amount - Use in conjunction with grouped_invoice_by_order_item
 *
 * GROUPED_BY_DAY - Tehnically GROUP_BY_ORDER, but the order items are grouped by day, each orders item is a line intem on the invoice - Date - SKU - Order Name - Amount
 */
enum QBOGroupedInvoiceTypeEnum {
    STANDARD = "STANDARD",
    SUM_BY_ORDER = "SUM_BY_ORDER",
    GROUPED_BY_DAY = "GROUPED_BY_DAY",
}

export default QBOGroupedInvoiceTypeEnum;
